import { apiRequest } from "../lib/apiClient";
import type { OnboardingChecklistOut } from "./types";

/** `GET /onboarding/checklist` — any authenticated user, scoped to their own tenant. */
export async function getOnboardingChecklist(accessToken: string): Promise<OnboardingChecklistOut> {
  return apiRequest<OnboardingChecklistOut>("/onboarding/checklist", { accessToken });
}
